<template>
  <div class="max-w-full mx-auto my-5 border rounded-2xl px-6 py-6 bg-white dark:bg-gray-600 dark:border-gray-600">
    <div class="mb-5">
      <div>
        <h2 class="text-2xl font-semibold dark:text-gray-100 text-center">
          {{ isEditMode ? `Edit Ticket Schedule` : 'Create Ticket Schedule' }}
        </h2>
      </div>

      <!-- <div class="flex items-center gap-3">
        <button
          v-if="isEditMode"
          type="button"
          @click="toggleEnabled"
          class="px-4 py-2 rounded-md text-sm font-medium"
          :class="form.is_enabled ? 'bg-red-500 hover:bg-red-600 text-white' : 'bg-green-500 hover:bg-green-600 text-white'"
        >
          {{ form.is_enabled ? 'Disable Schedule' : 'Enable Schedule' }}
        </button>

        <button
          type="button"
          @click="$router.push({ name: 'ticketSchedules' })"
          class="px-4 py-2 rounded-md border border-gray-300 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-100 dark:border-gray-900 dark:hover:bg-gray-800"
        >
          Back to List
        </button>
      </div> -->
    </div>

    <div v-if="booting" class="py-16 text-center text-gray-600 dark:text-gray-100">
      Loading schedule form...
    </div>

    <form v-else @submit.prevent="submitSchedule">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-12">
        <div class="space-y-4">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="md:col-span-2" v-click-outside="closeClientDropdown">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Client <span
                  class="text-red-500">*</span></label>
              <div class="relative">
                <input type="text" v-model="form.companyname" @focus="dropdownState.client.visible = true"
                  @keydown.down.prevent="onKeyDown('client', 'down')" @keydown.up.prevent="onKeyDown('client', 'up')"
                  @keydown.enter.prevent="onEnter('client', setClient, 'ticketTypeInput')"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100"
                  placeholder="Client Name" />
                <button v-if="form.company_id && form.companyname" type="button" @click="clearClient"
                  class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-red-500">
                  <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>

              <ul v-if="dropdownState.client.visible" data-field="client"
                class="absolute z-10 bg-white mt-1 rounded-md shadow-lg w-[calc(50%-3rem)] max-w-[48rem] dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100 scrollable-requester-list">
                <li v-for="(client, index) in filteredClients" :key="client.id" @click="setClient(client)" :class="[
                  'cursor-pointer p-3',
                  dropdownState.client.index === index
                    ? 'bg-blue-100 dark:bg-gray-700 active-item'
                    : 'hover:bg-gray-100 dark:hover:bg-gray-800'
                ]">
                  {{ client.companyname }}
                </li>
              </ul>
            </div>
            <div class="md:col-span-2" v-click-outside="closeTypeDropdown">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Ticket Type <span
                  class="text-red-500">*</span></label>
              <div class="relative">
                <input ref="ticketTypeInput" type="text" v-model="form.tickettype"
                  @focus="dropdownState.type.visible = true" @keydown.down.prevent="onKeyDown('type', 'down')"
                  @keydown.up.prevent="onKeyDown('type', 'up')"
                  @keydown.enter.prevent="onEnter('type', setReqType, 'ticketReqInput')"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100"
                  placeholder="Type" />
                <button v-if="form.tickettype && form.tickettype_id" type="button" @click="clearReqType"
                  class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-red-500">
                  <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>

              <ul v-if="dropdownState.type.visible" data-field="type"
                class="absolute z-10 bg-white mt-1 rounded-md shadow-lg w-[calc(50%-3rem)] max-w-[48rem] dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100 scrollable-requester-list">
                <li v-for="(reqtype, index) in filteredReqTypes" :key="reqtype.id" @click="setReqType(reqtype)" :class="[
                  'cursor-pointer p-3',
                  dropdownState.type.index === index
                    ? 'bg-blue-100 dark:bg-gray-700 active-item'
                    : 'hover:bg-gray-100 dark:hover:bg-gray-800'
                ]">
                  {{ reqtype.description }}
                </li>
              </ul>
            </div>

            <div class="md:col-span-2 mt-2">
              <div
                class="p-4 bg-white shadow-md rounded-md border-2 border-blue-900 relative dark:text-gray-100 dark:bg-gray-400 dark:border-gray-800">
                <div class="absolute top-0 left-0 right-0 bg-blue-900 px-3 py-1 flex items-center dark:bg-gray-800">
                  <h4 class="text-white font-bold text-sm">Requested By</h4>
                </div>

                <div class="md:col-span-2 mt-4">
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div class="flex space-x-2">
                      <div class="flex-grow" v-click-outside="closeReqDropdown">
                        <div class="relative">
                          <input ref="ticketReqInput" type="text" v-model="form.requester"
                            @focus="dropdownState.requester.visible = true"
                            @keydown.down.prevent="onKeyDown('requester', 'down')"
                            @keydown.up.prevent="onKeyDown('requester', 'up')"
                            @keydown.enter.prevent="onEnter('requester', setRequester, null, false)"
                            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm text-xs dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100 dark:placeholder-gray-100"
                            placeholder="Select Requester" />
                          <button v-if="form.requester && form.contact_id" type="button" @click="clearReq"
                            class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-red-500">
                            <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                              <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            </svg>
                          </button>
                        </div>

                        <ul v-if="dropdownState.requester.visible" data-field="requester"
                          class="absolute z-10 bg-white mt-1 rounded-md shadow-lg w-[calc(25%-0.5rem)] min-w-[22rem] dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100 scrollable-requester-list">
                          <li v-for="(req, index) in filteredRequesters" :key="req.id" @click="setRequester(req, false)"
                            :class="[
                              'cursor-pointer p-3',
                              dropdownState.requester.index === index
                                ? 'bg-blue-100 dark:bg-gray-700 active-item'
                                : 'hover:bg-gray-100 dark:hover:bg-gray-800'
                            ]">
                            {{ req.name }}<span v-if="req.email"> - {{ req.email }}</span>
                            <span v-if="req.user_type"> ({{ req.user_type }})</span>
                            <span v-if="requesterCompanyLabel(req)" :title="requesterCompanyTitle(req)"> ({{ requesterCompanyLabel(req) }})</span>
                          </li>
                        </ul>
                      </div>

                      <div class="shrink-0">
                        <button type="button" @click="showAddUserModal = true"
                          class="mt-2 bg-gray-400 p-1 border rounded text-xs leading-none dark:text-gray-100 dark:border-gray-900 dark:bg-gray-900">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                          </svg>
                        </button>
                      </div>
                    </div>

                    <div v-click-outside="closeIntReqDropdown">
                      <div class="relative">
                        <input type="text" v-model="form.intrequester"
                          @focus="dropdownState.internalRequester.visible = true"
                          @keydown.down.prevent="onKeyDown('internalRequester', 'down')"
                          @keydown.up.prevent="onKeyDown('internalRequester', 'up')"
                          @keydown.enter.prevent="onEnter('internalRequester', setRequester, null, true)"
                          class="mt-1 block w-full rounded-md border-gray-300 shadow-sm text-xs dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100 dark:placeholder-gray-100"
                          placeholder="Select Internal Requester" />
                        <button v-if="form.intrequester && form.contact_id" type="button" @click="clearIntReq"
                          class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-red-500">
                          <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" />
                            <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" />
                          </svg>
                        </button>
                      </div>

                      <ul v-if="dropdownState.internalRequester.visible" data-field="internalRequester"
                        class="absolute z-10 bg-white mt-1 rounded-md shadow-lg w-[calc(25%-0.5rem)] min-w-[22rem] dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100 scrollable-requester-list">
                        <li v-for="(req, index) in filteredIntRequesters" :key="req.id" @click="setRequester(req, true)"
                          :class="[
                            'cursor-pointer p-3',
                            dropdownState.internalRequester.index === index
                              ? 'bg-blue-100 dark:bg-gray-700 active-item'
                              : 'hover:bg-gray-100 dark:hover:bg-gray-800'
                          ]">
                          {{ req.name }}<span v-if="req.email"> - {{ req.email }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="md:col-span-2 mt-4">
                  <div class="grid grid-cols-1 md:grid-cols-1 gap-1">
                    <div>
                      <div class="flex justify-left mt-2">
                        <label class="block font-medium text-gray-700 text-xs dark:text-gray-100 mt-2 mr-2">
                          Add a Watcher?
                        </label>
                        <button type="button" @click="toggleWatcher"
                          class="mt-1 bg-gray-400 p-1 border rounded text-xs leading-none dark:text-gray-100 dark:border-gray-900 dark:bg-gray-900 transition-transform duration-300"
                          :class="{ 'transform rotate-180': showWatcher }">
                          <svg
                            :class="{ 'fill-current text-gray-100': !showWatcher, 'fill-current text-blue-500': showWatcher }"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="h-4 w-4">
                            <path
                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                          </svg>
                        </button>
                      </div>

                      <transition name="slide-fade">
                        <div v-click-outside="closeWatcherDropdown">
                          <input v-if="showWatcher" type="email" v-model="watchersInput"
                            @focus="dropdownState.watcher.visible = true"
                            @keydown.down.prevent="onKeyDown('watcher', 'down')"
                            @keydown.up.prevent="onKeyDown('watcher', 'up')"
                            @keydown.enter.prevent="onEnter('watcher', addWatcher, null)"
                            class="mt-1 block w-full rounded-md border border-gray-300 shadow-sm text-xs dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100 dark:placeholder-gray-100 transition-all duration-300 ease-in-out"
                            placeholder="Type to search from the contact list" />

                          <ul v-if="showWatcher && dropdownState.watcher.visible" data-field="watcher"
                            class="absolute z-10 bg-white mt-1 rounded-md shadow-lg w-[calc(50%-3rem)] max-w-[48rem] dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100 scrollable-requester-list">
                            <li v-for="(watcher, index) in filteredWatchers" :key="watcher.id"
                              @click="addWatcher(watcher)" :class="[
                                'cursor-pointer p-3',
                                dropdownState.watcher.index === index
                                  ? 'bg-blue-100 dark:bg-gray-700 active-item'
                                  : 'hover:bg-gray-100 dark:hover:bg-gray-800'
                              ]">
                              {{ watcher.name }}
                            </li>
                          </ul>

                          <div class="mt-1 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-1">
                            <div v-for="watcher in visibleWatchers" :key="watcher.id"
                              class="flex justify-between items-center border border-gray-200 rounded-full p-1 text-xs dark:border-gray-900 dark:bg-gray-400">
                              {{ watcher.name }}
                              <button type="button" @click="removeWatcher(watcher)"
                                class="ml-2 bg-red-600 hover:bg-red-700 text-white p-1 rounded-full text-xs">
                                &times;
                              </button>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <AddRequesterModal :isVisible="showAddUserModal" @close="showAddUserModal = false"
              @complete="handleAddUserCompletion" />

            <div class="flex space-x-2">
              <div class="mt-2 flex-grow">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Email <span
                    class="text-red-500">*</span></label>
                <input type="email" v-model="form.email"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100"
                  placeholder="Email" />
              </div>
              <div class="shrink-0 mt-8">
                <input id="notifyCheckbox" type="checkbox"
                  class="form-checkbox h-4 w-4 text-blue-600 dark:text-gray-900 rounded"
                  v-model="notifyCheckboxModel" />
                <label for="notifyCheckbox" class="ml-1 text-xs font-medium text-gray-700 dark:text-gray-100">
                  Notify
                </label>
              </div>
            </div>

            <div class="flex space-x-2">
              <div class="mt-2 flex-grow">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Phone Number <span
                    class="text-red-500">*</span></label>
                <input type="text" v-model="form.phone"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100"
                  placeholder="xxxxxxxxxx" />
              </div>
              <div class="shrink-0 mt-8">
                <div class="flex flex-col space-y-2">
                  <div class="flex items-center">
                    <input id="publishCheckbox" type="checkbox"
                      class="form-checkbox h-4 w-4 text-blue-600 dark:text-gray-900 rounded"
                      v-model="unPublishedCheckboxModel" />
                    <label for="publishCheckbox" class="ml-1 text-xs font-medium text-gray-700 dark:text-gray-100">
                      DO NOT Publish
                    </label>
                  </div>
                  <div class="flex items-center">
                    <input id="internalCheckbox" type="checkbox"
                      class="form-checkbox h-4 w-4 text-blue-600 dark:text-gray-900 rounded"
                      v-model="internalCheckboxModel" />
                    <label for="internalCheckbox" class="ml-1 text-xs font-medium text-gray-700 dark:text-gray-100">
                      Internal
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-3 md:col-span-2">
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Estimated Hours</label>
                <input type="number" step="0.25" min="0" v-model="form.est_time"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100"
                  placeholder="Estimated Hours" />
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Quick Estimated Hours</label>
                <select v-model="form.est_time"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                  <option :value="null">Select</option>
                  <option value="0.10">0.10</option>
                  <option value="0.25">0.25</option>
                  <option value="0.50">0.50</option>
                  <option value="0.75">0.75</option>
                  <option value="1.00">1.00</option>
                  <option value="1.50">1.50</option>
                  <option value="2.00">2.00</option>
                  <option value="3.00">3.00</option>
                  <option value="4.00">4.00</option>
                </select>
              </div>
            </div>

            <div class="flex space-x-2">
              <div class="flex-grow">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Assign To</label>
                <select v-model="form.tech_id"
                  class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                  <option :value="0">Send to Delegator</option>
                  <template v-for="(techList, deptName) in groupedTechnicians" :key="deptName">
                    <optgroup v-if="deptName" :label="deptName">
                      <option v-for="tech in techList" :key="tech.id" :value="tech.id">
                        {{ tech.name }}
                      </option>
                    </optgroup>
                    <template v-else>
                      <option v-for="tech in techList" :key="tech.id" :value="tech.id">
                        {{ tech.name }}
                      </option>
                    </template>
                  </template>
                </select>
              </div>

            </div>
          </div>
        </div>

        <div class="space-y-4">
          <div class="md:col-span-2 relative">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Description <span
                class="text-red-500">*</span></label>
            <textarea v-model="form.description" rows="5"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100" />
            <button type="button" @click="activateTextArea('description')"
              class="absolute right-2 bg-gray-400 bottom-2 p-1 border rounded text-xs leading-none dark:text-gray-100 dark:border-gray-900 dark:bg-gray-900"
              style="margin-right: 1rem">
              [ ]
            </button>
          </div>
          <div class="md:col-span-2 relative">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Notes / Direction (Public)</label>
            <textarea v-model="form.delegatornotes" rows="5"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100" />
            <button type="button" @click="activateTextArea('delegatornotes')"
              class="absolute right-2 bg-gray-400 bottom-2 p-1 border rounded text-xs leading-none dark:text-gray-100 dark:border-gray-900 dark:bg-gray-900"
              style="margin-right: 1rem">
              [ ]
            </button>
          </div>
          <div
            class="p-4 bg-white shadow-md rounded-md border-2 border-blue-900 relative dark:text-gray-100 dark:bg-gray-400 dark:border-gray-800">
            <div class="absolute top-0 left-0 right-0 bg-blue-900 px-3 py-1 flex items-center dark:bg-gray-800">
              <h4 class="text-white font-bold text-sm">Schedule Settings</h4>
            </div>

            <div class="pt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="md:col-span-2">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Enabled</label>
                <div class="mt-2">
                  <label class="inline-flex items-center cursor-pointer">
                    <input type="checkbox" class="sr-only peer" v-model="enabledCheckboxModel">
                    <div
                      class="w-11 h-6 bg-gray-300 rounded-full peer dark:bg-gray-700 peer-checked:bg-green-500 relative transition-colors">
                      <div class="absolute top-[2px] left-[2px] bg-white w-5 h-5 rounded-full transition-transform"
                        :class="form.is_enabled ? 'translate-x-5' : ''" />
                    </div>
                    <span class="ml-3 text-sm text-gray-700 dark:text-gray-100">
                      {{ form.is_enabled ? 'Enabled' : 'Disabled' }}
                    </span>
                  </label>
                </div>
              </div>
              <div class="md:col-span-2">
                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Schedule Type <span
                      class="text-red-500">*</span></label>
                  <select v-model="form.schedule_type"
                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                    <option value="quarterly">Quarterly</option>
                    <option value="yearly">Yearly</option>
                  </select>
                </div>
              </div>
              <div class="md:col-span-2" v-if="form.schedule_type !== 'quarterly'">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">
                  Repeat Every <span class="text-red-500">*</span>
                </label>
                <div class="mt-1 flex items-center gap-2">
                  <input type="number" min="1" max="999" v-model.number="form.interval_value"
                    class="block w-28 rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100"
                    placeholder="1" />
                  <span class="text-sm text-gray-700 dark:text-gray-100">{{ intervalUnitLabel }}</span>
                </div>
                <p class="text-xs text-gray-500 dark:text-gray-200 mt-1">
                  Defaults to 1. Use higher values for custom intervals (e.g. every 25 days, every 6 weeks, every 5 months, every 3 years).
                </p>
              </div>
              <div class="md:col-span-2" v-if="showStartDate">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">
                  Start Date (Optional)
                </label>
                <input type="date" v-model="form.start_date" @change="onStartDateChange"
                  class="mt-1 block w-full md:w-64 rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100" />
                <p class="text-xs text-gray-500 dark:text-gray-200 mt-1">
                  {{ startDateHelpText }}
                </p>
              </div>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-3 md:col-span-2">
                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">
                    Promised Time <span class="text-red-500">*</span>
                  </label>
                  <input type="time" v-model="form.promised_time" step="60"
                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100" />
                  <p class="text-xs text-gray-500 dark:text-gray-200 mt-1">
                    This time will be used with the promised date when creating the ticket.
                  </p>
                </div>
                <div v-if="form.schedule_type !== 'daily' || Number(form.interval_value || 1) > 1">
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Lead Time (Days) <span
                      class="text-red-500">*</span></label>
                  <input type="number" min="0" v-model.number="form.lead_time_days"
                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100"
                    placeholder="Default 7" />
                  <p class="text-xs text-gray-500 dark:text-gray-200 mt-1">
                    Ticket command will create the ticket this many days before the actual promised date.
                  </p>
                </div>
              </div>

              <template v-if="form.schedule_type === 'weekly'">
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Day of Week <span
                      class="text-red-500">*</span></label>
                  <select v-model="form.day_of_week"
                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                    <option :value="null">Select Day</option>
                    <option :value="1">Monday</option>
                    <option :value="2">Tuesday</option>
                    <option :value="3">Wednesday</option>
                    <option :value="4">Thursday</option>
                    <option :value="5">Friday</option>
                    <option :value="6">Saturday</option>
                    <option :value="7">Sunday</option>
                  </select>
                </div>
              </template>

              <template v-if="form.schedule_type === 'monthly'">
                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Day of Month</label>
                  <input type="number" min="1" max="31" :disabled="form.is_last_day_of_month === 1"
                    v-model.number="form.day_of_month"
                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm disabled:bg-gray-100 dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100 dark:disabled:bg-gray-500"
                    placeholder="1 - 31" />
                </div>

                <div class="flex items-end">
                  <label class="inline-flex items-center">
                    <input type="checkbox" class="form-checkbox h-4 w-4 text-blue-600 dark:text-gray-900 rounded"
                      v-model="lastDayCheckboxModel" />
                    <span class="ml-2 text-sm text-gray-700 dark:text-gray-100">Use last day of month</span>
                  </label>
                </div>
              </template>

              <template v-if="form.schedule_type === 'quarterly'">
                <div class="md:col-span-2">
                  <p class="text-xs text-gray-500 dark:text-gray-200">
                    Quarterly schedules fire every 3 months from the anchor month/day below.
                  </p>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Anchor Month <span
                      class="text-red-500">*</span></label>
                  <select v-model.number="form.month_of_year"
                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                    <option :value="null">Select Month</option>
                    <option :value="1">January (Jan / Apr / Jul / Oct)</option>
                    <option :value="2">February (Feb / May / Aug / Nov)</option>
                    <option :value="3">March (Mar / Jun / Sep / Dec)</option>
                  </select>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Day of Month</label>
                  <input type="number" min="1" max="31" :disabled="form.is_last_day_of_month === 1"
                    v-model.number="form.day_of_month"
                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm disabled:bg-gray-100 dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100 dark:disabled:bg-gray-500"
                    placeholder="1 - 31" />
                </div>

                <div class="md:col-span-2 flex items-end">
                  <label class="inline-flex items-center">
                    <input type="checkbox" class="form-checkbox h-4 w-4 text-blue-600 dark:text-gray-900 rounded"
                      v-model="lastDayCheckboxModel" />
                    <span class="ml-2 text-sm text-gray-700 dark:text-gray-100">Use last day of anchor month</span>
                  </label>
                </div>
              </template>

              <template v-if="form.schedule_type === 'yearly'">
                <!-- <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Yearly Mode</label>
                  <select
                    v-model="form.yearly_anchor"
                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100"
                  >
                    <option value="specific_day">Specific Month / Day</option>
                    <option value="first_day_of_year">First Day of Year</option>
                    <option value="last_day_of_year">Last Day of Year</option>
                  </select>
                </div> -->
                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Month</label>
                  <select v-model.number="form.month_of_year"
                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                    <option :value="null">Select Month</option>
                    <option :value="1">January</option>
                    <option :value="2">February</option>
                    <option :value="3">March</option>
                    <option :value="4">April</option>
                    <option :value="5">May</option>
                    <option :value="6">June</option>
                    <option :value="7">July</option>
                    <option :value="8">August</option>
                    <option :value="9">September</option>
                    <option :value="10">October</option>
                    <option :value="11">November</option>
                    <option :value="12">December</option>
                  </select>
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Day</label>
                  <input type="number" min="1" max="31" v-model.number="form.day_of_month"
                    class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100"
                    placeholder="1 - 31" />
                </div>
              </template>
              <!-- <div v-if="isEditMode && lastCreatedSummary" class="md:col-span-2">
                <div class="rounded-lg border border-yellow-300 bg-yellow-50 px-4 py-3 dark:bg-yellow-900/30 dark:border-yellow-700">
                  <div class="text-sm font-semibold text-gray-900 dark:text-gray-100">Last Created Ticket</div>
                  <div class="text-sm text-gray-700 dark:text-gray-200 mt-1">
                    {{ lastCreatedSummary }}
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="md:col-span-2 text-center mt-6 flex justify-center space-x-4">
        <button type="submit" :disabled="submitting"
          class="mt-6 px-6 py-2 border border-transparent text-base font-medium rounded-md text-white bg-yellow-500 hover:bg-yellow-700 disabled:opacity-60">
          {{ submitting ? 'Saving...' : (isEditMode ? 'Update Schedule' : 'Add Schedule') }}
        </button>

        <button type="button" @click="cancel"
          class="mt-6 px-6 py-2 border border-transparent text-base font-medium rounded-md text-white bg-red-500 hover:bg-red-700">
          Cancel
        </button>
      </div>

      <LargeTextareaModal :isVisible="showTextArea" :initialText="getTextareaInitialText()"
        :activeTextarea="activeTextarea" @close="showTextArea = false" @complete="handleTextCompletion" />
    </form>
  </div>
</template>

<script>
import { requesterCompanyLabel, requesterCompanyTitle } from '@/utils/requesterCompanies';
import { searchRequesters } from '@/utils/requesterSearch';
import axios from 'axios'
import LargeTextareaModal from '@/views/modals/LargeTextareaModal.vue'
import AddRequesterModal from '@/views/modals/AddRequesterModal.vue'
import { useToast } from 'vue-toastification'

export default {
  name: 'AddEditTicketSchedule',
  components: {
    LargeTextareaModal,
    AddRequesterModal
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  setup() {
    const toast = useToast()
    return { toast }
  },
  data() {
    return {
      booting: true,
      submitting: false,
      showTextArea: false,
      activeTextarea: '',
      showWatcher: false,
      showAddUserModal: false,

      userroles: [],
      userPermissions: [],

      clients: [],
      requesters: [],
      allRequesters: [],
      intRequesters: [],
      ticketTypes: [],
      technicians: [],
      clientNotes: {
        notes: '',
        warning: ''
      },

      watchersInput: '',

      dropdownState: {
        client: { index: -1, items: [], visible: false },
        type: { index: -1, items: [], visible: false },
        requester: { index: -1, items: [], visible: false },
        internalRequester: { index: -1, items: [], visible: false },
        watcher: { index: -1, items: [], visible: false }
      },

      form: this.defaultForm()
    }
  },
  computed: {
    scheduleId() {
      return this.$route.params.id || this.id || null
    },
    isEditMode() {
      return !!this.scheduleId
    },
    visibleWatchers() {
      return (this.form.watchersList || []).filter(w => w.visible)
    },
    groupedTechnicians() {
      const groups = {}
      const ungrouped = []

        ; (this.technicians || []).forEach(tech => {
          if (!tech.deptId) {
            ungrouped.push({ id: tech.id, name: tech.name })
            return
          }

          let groupKey = ''
          if (tech.deptId === 'External Tech') {
            groupKey = 'External Tech'
          } else if (tech.details) {
            groupKey = tech.details
          } else {
            groupKey = 'Other Department'
          }

          if (!groups[groupKey]) groups[groupKey] = []

          let displayName = tech.name
          if (tech.deptId === 'External Tech' && tech.details) {
            displayName += ` (${tech.details})`
          }

          groups[groupKey].push({
            id: tech.id,
            name: displayName
          })
        })

      if (ungrouped.length > 0) groups[''] = ungrouped

      const keys = Object.keys(groups).filter(k => k !== 'External Tech').sort((a, b) => {
        if (a === '') return -1
        if (b === '') return 1
        return a.localeCompare(b)
      })

      if (groups['External Tech']) keys.push('External Tech')

      const orderedGroups = {}
      keys.forEach(key => {
        orderedGroups[key] = groups[key]
      })

      return orderedGroups
    },
    filteredClients() {
      const filtered = this.form.companyname
        ? this.clients.filter(e =>
          (e.companyname || '').toLowerCase().includes(this.form.companyname.toLowerCase())
        )
        : this.clients
      this.dropdownState.client.items = filtered
      return filtered
    },
    filteredReqTypes() {
      const filtered = this.form.tickettype
        ? this.ticketTypes.filter(e =>
          (e.description || '').toLowerCase().includes(this.form.tickettype.toLowerCase())
        )
        : this.ticketTypes
      this.dropdownState.type.items = filtered
      return filtered
    },
    filteredRequesters() {
      const q = (this.form.requester || '').toLowerCase()
      const filtered = q
        // Typing: search across ALL requesters system-wide, the selected client's
        // own people listed first.
        ? searchRequesters(this.requesters, q, this.form.company_id, { clientList: this.allRequesters })
        // Empty: this client's requesters when a client is selected, else all.
        : (this.form.company_id ? this.allRequesters.slice(0, 20) : this.requesters.slice(0, 20))

      this.dropdownState.requester.items = filtered
      return filtered
    },
    filteredIntRequesters() {
      const source = this.intRequesters || []
      const filtered = this.form.intrequester
        ? source.filter(e =>
          (e.name || '').toLowerCase().includes(this.form.intrequester.toLowerCase())
        ).slice(0, 20)
        : source.slice(0, 20)

      this.dropdownState.internalRequester.items = filtered
      return filtered
    },
    filteredWatchers() {
      const filtered = this.watchersInput
        ? this.allRequesters.filter(e =>
          (e.name || '').toLowerCase().includes(this.watchersInput.toLowerCase())
        ).slice(0, 20)
        : this.allRequesters.slice(0, 20)

      this.dropdownState.watcher.items = filtered
      return filtered
    },
    notifyCheckboxModel: {
      get() {
        return Number(this.form.emailnotification) === 1
      },
      set(value) {
        this.form.emailnotification = value ? 1 : 0
      }
    },
    unPublishedCheckboxModel: {
      get() {
        return Number(this.form.unpublished) === 1
      },
      set(value) {
        this.form.unpublished = value ? 1 : 0
      }
    },
    internalCheckboxModel: {
      get() {
        return Number(this.form.internal) === 1
      },
      set(value) {
        this.form.internal = value ? 1 : 0
      }
    },
    enabledCheckboxModel: {
      get() {
        return Number(this.form.is_enabled) === 1
      },
      set(value) {
        this.form.is_enabled = value ? 1 : 0
      }
    },
    intervalUnitLabel() {
      const n = Number(this.form.interval_value || 1)
      const plural = n === 1 ? '' : 's'
      const map = {
        daily: `day${plural}`,
        weekly: `week${plural}`,
        monthly: `month${plural}`,
        quarterly: `quarter${plural}`,
        yearly: `year${plural}`
      }
      return map[this.form.schedule_type] || ''
    },
    showStartDate() {
      if (this.form.schedule_type === 'daily') {
        return Number(this.form.interval_value || 1) > 1
      }
      return ['weekly', 'monthly', 'quarterly', 'yearly'].includes(this.form.schedule_type)
    },
    startDateHelpText() {
      const type = this.form.schedule_type
      if (type === 'daily') {
        return `Anchor the every-${Number(this.form.interval_value)}-day cadence to this date. Leave blank to start today. If the date is in the past, the next occurrence on the cadence will be used.`
      }
      if (type === 'weekly') {
        return 'First occurrence on or after this date. Day of week auto-fills from it. Leave blank to use the next matching weekday from today.'
      }
      if (type === 'monthly') {
        return 'First occurrence on or after this date. Day of month auto-fills from it. Leave blank to use this month (or next, if the day has passed).'
      }
      if (type === 'quarterly') {
        return 'First occurrence on or after this date. Anchor month and day auto-fill from it. Leave blank to use the next quarterly slot from today.'
      }
      if (type === 'yearly') {
        return 'First occurrence on or after this date. Month and day auto-fill from it. Leave blank to use this year (or next, if the date has passed).'
      }
      return ''
    },
    lastDayCheckboxModel: {
      get() {
        return Number(this.form.is_last_day_of_month) === 1
      },
      set(value) {
        this.form.is_last_day_of_month = value ? 1 : 0
        if (value) this.form.day_of_month = null
      }
    },
    // lastCreatedSummary() {
    //   const pieces = []
    //   if (this.form.last_created_ticket_number) pieces.push(`Ticket: ${this.form.last_created_ticket_number}`)
    //   else if (this.form.last_created_ticket_id) pieces.push(`Ticket ID: ${this.form.last_created_ticket_id}`)

    //   if (this.form.last_created_occurrence_date) {
    //     pieces.push(`Occurrence: ${this.formatDate(this.form.last_created_occurrence_date)}`)
    //   }

    //   return pieces.join(' • ')
    // }
  },
  watch: {
    'form.company_id': {
      immediate: false,
      async handler(newVal) {
        if (!newVal) {
          this.allRequesters = []
          this.ticketTypes = []
          this.technicians = []
          this.clientNotes = { notes: '', warning: '' }
          return
        }

        await this.loadCompanySpecificData(newVal)
      }
    },
    'form.schedule_type'(value) {
      if (value === 'daily') {
        this.form.day_of_week = null
        this.form.day_of_month = null
        if (Number(this.form.interval_value || 1) <= 1) {
          this.form.lead_time_days = 0
          this.form.start_date = null
        }
        this.form.is_last_day_of_month = 0
        this.form.month_of_year = null
      } else if (value === 'weekly') {
        this.form.day_of_month = null
        this.form.is_last_day_of_month = 0
        this.form.month_of_year = null
      } else if (value === 'monthly') {
        this.form.day_of_week = null
        this.form.month_of_year = null
      } else if (value === 'quarterly') {
        this.form.day_of_week = null
        this.form.interval_value = 1
      } else if (value === 'yearly') {
        this.form.day_of_week = null
        this.form.is_last_day_of_month = 0
      }
    },
    'form.interval_value'(value) {
      if (this.form.schedule_type === 'daily' && Number(value || 1) <= 1) {
        this.form.start_date = null
      }
    },
  },
  async mounted() {
    const allowed = await this.bootstrapAccess()
    if (!allowed) return

    await this.fetchBaseData()

    if (this.isEditMode) {
      await this.loadSchedule()
    }

    this.booting = false
  },
  methods: {
    requesterCompanyLabel,
    requesterCompanyTitle,
    defaultForm() {
      return {
        is_enabled: 1,
        schedule_type: 'daily',
        interval_value: 1,
        start_date: null,
        day_of_week: null,
        day_of_month: null,
        is_last_day_of_month: 0,
        month_of_year: null,
        promised_time: '17:00',
        lead_time_days: 0,

        company_id: '',
        companyname: '',
        contact_id: null,
        tech_id: 0,
        tickettype_id: '',
        tickettype: '',

        requester: '',
        intrequester: '',
        email: '',
        phone: '',
        description: '',
        delegatornotes: '',

        emailnotification: 0,
        internal: 0,
        unpublished: 0,
        est_time: null,

        watchersList: []
        // last_created_ticket_id: null,
        // last_created_ticket_number: '',
        // last_created_occurrence_date: null
      }
    },
    async bootstrapAccess() {
      try {
        const userId = localStorage.getItem('user_id')
        const roleResponse = await axios.get(`user/role/${userId}`)
        this.userroles = roleResponse.data.roles || []
        this.userPermissions = roleResponse.data.user_permissions || []

        if (!this.hasSchedulerAccess()) {
          this.toast.error('You do not have access to Ticket Schedules.')
          this.$router.replace({ name: 'viewTickets' })
          return false
        }

        return true
      } catch (error) {
        console.error('Error loading user access:', error)
        this.toast.error('Failed to verify scheduler access.')
        this.$router.replace({ name: 'viewTickets' })
        return false
      }
    },
    hasUserPermission(module, name) {
      return (this.userPermissions || []).some(p =>
        p.module === module &&
        p.name === name &&
        String(p.value) !== '0'
      )
    },
    hasSchedulerAccess() {
      const roles = this.userroles || []
      const byRole = roles.includes(10) || roles.includes(20)
      return byRole || this.hasUserPermission('ticket_scheduler', 'access')
    },
    async fetchBaseData() {
      try {
        this.$updateLoading?.(1)

        const [clientsRes, internalReqRes, allReqRes] = await Promise.all([
          axios.get('clients/'),
          axios.get('requesters/internal'),
          // System-wide requester list — the search source so typing matches
          // requesters at any client, not just the selected one.
          axios.get('requesters/')
        ])

        this.clients = clientsRes.data || []
        this.intRequesters = internalReqRes.data || []
        this.requesters = allReqRes.data || []
      } catch (error) {
        console.error('Error fetching base data:', error)
        this.toast.error('Failed to load schedule form data.')
      } finally {
        this.$updateLoading?.(-1)
      }
    },
    async loadCompanySpecificData(companyId) {
      try {
        this.$updateLoading?.(1)

        // Drop the previous client's people now, so the requester typeahead doesn't
        // rank them first for the new client while this list is still loading.
        this.allRequesters = []
        const [requestersRes, ticketTypesRes, techsRes, notesRes] = await Promise.all([
          axios.get(`requesters/${companyId}`),
          axios.get(`ticket/get-types/${companyId}`),
          axios.get(`${axios.defaults.baseURL}user/active/${companyId}`),
          axios.get('clients/notes', { params: { id: companyId } })
        ])

        this.allRequesters = requestersRes.data || []
        this.ticketTypes = ticketTypesRes.data || []
        this.technicians = techsRes.data || []

        const notesData = notesRes.data || {}
        this.clientNotes = {
          notes: (notesData.notes || '').trim(),
          warning: (notesData.warning || '').trim()
        }
      } catch (error) {
        console.error('Error loading company-specific data:', error)
        this.toast.error('Failed to load company-specific schedule data.')
      } finally {
        this.$updateLoading?.(-1)
      }
    },
    async loadSchedule() {
      try {
        this.$updateLoading?.(1)
        const response = await axios.get(`ticket-schedules/${this.scheduleId}`)
        const schedule = response.data || {}

        this.form = {
          ...this.defaultForm(),
          ...schedule,
          companyname: schedule.company_name || schedule.companyname || '',
          tickettype: schedule.tickettype_description || schedule.tickettype || '',
          watchersList: this.normalizeWatchers(schedule.watchers_json)
        }

        if (this.form.company_id) {
          await this.loadCompanySpecificData(this.form.company_id)

          if (!this.form.companyname) {
            const client = this.clients.find(c => Number(c.id) === Number(this.form.company_id))
            if (client) this.form.companyname = client.companyname
          }

          if (!this.form.tickettype && this.form.tickettype_id) {
            const type = this.ticketTypes.find(t => Number(t.id) === Number(this.form.tickettype_id))
            if (type) this.form.tickettype = type.description
          }

          if (!this.form.requester && this.form.contact_id) {
            const req = this.allRequesters.find(r => Number(r.id) === Number(this.form.contact_id))
            if (req) this.form.requester = req.name
          }

          if (!this.form.intrequester && this.form.contact_id) {
            const intReq = this.intRequesters.find(r => Number(r.id) === Number(this.form.contact_id))
            if (intReq) this.form.intrequester = intReq.name
          }
        }
      } catch (error) {
        console.error('Error loading schedule:', error)
        this.toast.error('Failed to load ticket schedule.')
        this.$router.replace({ name: 'ticketSchedules' })
      } finally {
        this.$updateLoading?.(-1)
      }
    },
    normalizeWatchers(watchers) {
      if (!watchers) return []

      if (Array.isArray(watchers)) {
        return watchers.map(w => ({
          id: w.id,
          name: w.name || w.label || `Watcher #${w.id}`,
          visible: w.visible !== false
        }))
      }

      return []
    },
    onKeyDown(field, direction) {
      const state = this.dropdownState[field]
      if (!state.visible || state.items.length === 0) return

      if (direction === 'down') {
        state.index = (state.index + 1) % state.items.length
      } else if (direction === 'up') {
        state.index = (state.index - 1 + state.items.length) % state.items.length
      }

      this.$nextTick(() => {
        const container = this.$el.querySelector(`.scrollable-requester-list[data-field="${field}"]`)
        const activeItem = container?.querySelector('.active-item')
        activeItem?.scrollIntoView({ block: 'nearest' })
      })
    },
    onEnter(field, selectFn, nextRef = null, ...args) {
      const state = this.dropdownState[field]
      if (state.index >= 0 && state.index < state.items.length) {
        selectFn(state.items[state.index], ...args)
        state.index = -1
        if (nextRef) {
          this.$nextTick(() => this.$refs[nextRef]?.focus())
        }
      }
    },
    closeClientDropdown() {
      this.dropdownState.client.visible = false
    },
    closeTypeDropdown() {
      this.dropdownState.type.visible = false
    },
    closeReqDropdown() {
      this.dropdownState.requester.visible = false
    },
    closeIntReqDropdown() {
      this.dropdownState.internalRequester.visible = false
    },
    closeWatcherDropdown() {
      this.dropdownState.watcher.visible = false
    },
    setClient(client) {
      this.form.company_id = client.id
      this.form.companyname = client.companyname
      this.form.contact_id = null
      this.form.requester = ''
      this.form.contact_id = null
      this.form.intrequester = ''
      this.form.email = ''
      this.form.phone = ''
      this.form.tickettype = ''
      this.form.tickettype_id = ''
      this.form.tech_id = 0
      this.form.watchersList = []
      this.dropdownState.client.visible = false
    },
    clearClient() {
      this.form.company_id = ''
      this.form.companyname = ''
      this.allRequesters = []
      this.ticketTypes = []
      this.technicians = []
      this.clientNotes = { notes: '', warning: '' }
    },
    setReqType(type) {
      this.form.tickettype_id = type.id
      this.form.tickettype = type.description
      this.dropdownState.type.visible = false
    },
    clearReqType() {
      this.form.tickettype_id = ''
      this.form.tickettype = ''
    },
    setRequester(req, isInternal = false) {
      if (isInternal) {
        this.form.contact_id = req.id
        this.form.intrequester = req.name
      } else {
        this.form.contact_id = req.id
        this.form.requester = req.name
      }

      if (req.email && !this.form.email) this.form.email = req.email
      if (req.phone_primary || req.phone_secondary) {
        this.form.phone = req.phone_primary || req.phone_secondary || this.form.phone
      }

      this.dropdownState.requester.visible = false
      this.dropdownState.internalRequester.visible = false
    },
    clearReq() {
      this.form.requester = ''
      this.form.contact_id = null
    },
    clearIntReq() {
      this.form.intrequester = ''
      this.form.contact_id = null
    },
    toggleWatcher() {
      this.showWatcher = !this.showWatcher
      if (!this.showWatcher) {
        this.watchersInput = ''
        this.dropdownState.watcher.visible = false
      }
    },
    addWatcher(watcher) {
      if (!this.form.watchersList.some(w => Number(w.id) === Number(watcher.id))) {
        this.form.watchersList.push({
          id: watcher.id,
          name: watcher.name,
          visible: true
        })
      }
      this.dropdownState.watcher.visible = false
      this.watchersInput = ''
    },
    removeWatcher(watcher) {
      const index = this.form.watchersList.findIndex(w => Number(w.id) === Number(watcher.id))
      if (index !== -1) {
        this.form.watchersList[index].visible = false
      }
    },
    handleAddUserCompletion({ newUser }) {
      this.form.requester = `${newUser.firstName} ${newUser.lastName}`.trim()
      this.form.email = newUser.email || this.form.email
      this.form.phone = newUser.phone || this.form.phone
      this.form.contact_id = null
      this.showAddUserModal = false
    },
    activateTextArea(key) {
      this.activeTextarea = key
      this.showTextArea = true
    },
    getTextareaInitialText() {
      if (this.activeTextarea === 'description') return this.form.description || ''
      if (this.activeTextarea === 'delegatornotes') return this.form.delegatornotes || ''
      return ''
    },
    handleTextCompletion({ updatedText, key }) {
      if (key === 'description') this.form.description = updatedText
      if (key === 'delegatornotes') this.form.delegatornotes = updatedText
      this.showTextArea = false
      this.activeTextarea = ''
    },
    validateForm() {
      const missing = []

      if (!this.form.company_id) missing.push('Client')
      if (!this.form.tickettype_id) missing.push('Ticket Type')
      if (!this.form.description?.trim()) missing.push('Description')
      if (!this.form.email?.trim()) missing.push('Email')
      if (!this.form.phone?.trim()) missing.push('Phone')
      if (!this.form.requester?.trim() && !this.form.intrequester?.trim()) {
        missing.push('Requester')
      }

      if (this.form.lead_time_days === '' || this.form.lead_time_days === null || Number(this.form.lead_time_days) < 0) {
        missing.push('Lead Time')
      }

      if (!this.form.promised_time?.trim()) {
        missing.push('Promised Time')
      }

      const interval = Number(this.form.interval_value)
      if (!Number.isInteger(interval) || interval < 1) {
        missing.push('Repeat Every (must be 1 or higher)')
      }

      if (this.form.schedule_type === 'weekly' && !this.form.day_of_week) {
        missing.push('Day of Week')
      }

      if (this.form.schedule_type === 'monthly') {
        if (!this.form.day_of_month && Number(this.form.is_last_day_of_month) !== 1) {
          missing.push('Monthly Day or Last Day')
        }
      }

      if (this.form.schedule_type === 'quarterly') {
        if (!this.form.month_of_year) missing.push('Quarterly Anchor Month')
        if (!this.form.day_of_month && Number(this.form.is_last_day_of_month) !== 1) {
          missing.push('Quarterly Day or Last Day')
        }
      }

      if (this.form.schedule_type === 'yearly') {
        if (!this.form.month_of_year) missing.push('Yearly Month')
        if (!this.form.day_of_month) missing.push('Yearly Day')
      }

      if (missing.length) {
        this.toast.error(`Please complete: ${missing.join(', ')}`)
        return false
      }

      return true
    },
    buildPayload() {
      return {
        is_enabled: Number(this.form.is_enabled) === 1 ? 1 : 0,
        schedule_type: this.form.schedule_type,
        interval_value: this.form.schedule_type === 'quarterly'
          ? 1
          : Math.max(1, Number(this.form.interval_value) || 1),
        start_date: this.startDatePayload(),
        day_of_week: this.form.schedule_type === 'weekly' ? this.form.day_of_week : null,
        day_of_month: ['monthly', 'quarterly', 'yearly'].includes(this.form.schedule_type) ? this.form.day_of_month : null,
        is_last_day_of_month: ['monthly', 'quarterly'].includes(this.form.schedule_type) ? (Number(this.form.is_last_day_of_month) === 1 ? 1 : 0) : 0,
        month_of_year: ['quarterly', 'yearly'].includes(this.form.schedule_type) ? this.form.month_of_year : null,
        promised_time: this.form.promised_time || null,
        lead_time_days: Number(this.form.lead_time_days),

        company_id: this.form.company_id,
        contact_id: this.form.contact_id || null,
        tech_id: this.form.tech_id || 0,
        tickettype_id: this.form.tickettype_id,

        requester: this.form.requester || this.form.intrequester || '',
        email: this.form.email || '',
        phone: this.form.phone || '',
        description: this.form.description || '',
        delegatornotes: this.form.delegatornotes || '',

        emailnotification: Number(this.form.emailnotification) === 1 ? 1 : 0,
        internal: Number(this.form.internal) === 1 ? 1 : 0,
        unpublished: Number(this.form.unpublished) === 1 ? 1 : 0,
        est_time: this.form.est_time === '' ? null : this.form.est_time,

        watchers_json: this.visibleWatchers.map(w => ({
          id: w.id,
          name: w.name,
          visible: true
        }))
      }
    },
    async submitSchedule() {
      if (!this.validateForm()) return

      this.submitting = true
      try {
        const payload = this.buildPayload()

        if (this.isEditMode) {
          await axios.post(`ticket-schedules/${this.scheduleId}`, payload)
          this.toast.success('Ticket schedule updated successfully.')
        } else {
          await axios.post('ticket-schedules', payload)
          this.toast.success('Ticket schedule created successfully.')
        }

        this.$router.push({ name: 'ticketSchedules' })
      } catch (error) {
        console.error('Error saving schedule:', error)

        if (error.response?.data?.errors) {
          const firstError = Object.values(error.response.data.errors)[0]
          if (Array.isArray(firstError) && firstError.length) {
            this.toast.error(firstError[0])
          } else {
            this.toast.error('Validation failed while saving schedule.')
          }
        } else {
          this.toast.error('Failed to save ticket schedule.')
        }
      } finally {
        this.submitting = false
      }
    },
    async toggleEnabled() {
      if (!this.isEditMode) {
        this.form.is_enabled = Number(this.form.is_enabled) === 1 ? 0 : 1
        return
      }

      try {
        const response = await axios.post(`ticket-schedules/toggle/${this.scheduleId}`)
        const updated = response.data?.data || null

        if (updated) {
          this.form.is_enabled = Number(updated.is_enabled) === 1 ? 1 : 0
        } else {
          this.form.is_enabled = Number(this.form.is_enabled) === 1 ? 0 : 1
        }

        this.toast.success(this.form.is_enabled ? 'Schedule enabled.' : 'Schedule disabled.')
      } catch (error) {
        console.error('Error toggling schedule:', error)
        this.toast.error('Failed to update schedule status.')
      }
    },
    cancel() {
      this.$router.push({ name: 'ticketSchedules' })
    },
    formatDate(value) {
      if (!value) return '—'
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return value
      return date.toLocaleDateString()
    },
    startDatePayload() {
      if (!this.form.start_date) return null
      if (this.form.schedule_type === 'daily' && Number(this.form.interval_value || 1) <= 1) {
        return null
      }
      return this.form.start_date
    },
    onStartDateChange() {
      const value = this.form.start_date
      if (!value) return

      const parts = String(value).split('-')
      if (parts.length !== 3) return

      const year = Number(parts[0])
      const month = Number(parts[1])
      const day = Number(parts[2])
      if (!year || !month || !day) return

      const date = new Date(Date.UTC(year, month - 1, day))
      if (Number.isNaN(date.getTime())) return

      const isoDow = ((date.getUTCDay() + 6) % 7) + 1
      const type = this.form.schedule_type

      if (type === 'weekly') {
        this.form.day_of_week = isoDow
      } else if (type === 'monthly') {
        this.form.day_of_month = day
        this.form.is_last_day_of_month = 0
      } else if (type === 'quarterly') {
        this.form.month_of_year = ((month - 1) % 3) + 1
        this.form.day_of_month = day
        this.form.is_last_day_of_month = 0
      } else if (type === 'yearly') {
        this.form.month_of_year = month
        this.form.day_of_month = day
      }
    }
  }
}
</script>

<style scoped>
.scrollable-requester-list {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #ccc;
}
</style>